export const CRYPTO_TICKERS = [
  'BTCUSD',
  'LTCUSD',
  'ETHUSD',
  'XRPUSD',
  'BCHUSD',
  'BTCEUR',
  'LTCEUR',
  'ETHEUR',
  'XRPEUR',
  'BCHEUR',
  'LTCBTC',
  'ETHBTC',
  'XRPBTC',
  'BCHBTC',
]

// Keep in sync with the copy in Charts repo - app/constants/common.ts
export enum TIMEFRAME {
  i1 = 'i1',
  i3 = 'i3',
  i5 = 'i5',
  i10 = 'i10',
  i15 = 'i15',
  i30 = 'i30',
  h = 'h',
  h2 = 'h2',
  h4 = 'h4',
  d = 'd',
  w = 'w',
  m = 'm',
}
